<p-menu #stockMenu [model]="menuItems" [popup]="true" />
<p-popover #stockPop (onHide)="selectedStock = null">
    <ng-template #content>
        @if (selectedStock) {
            <div class="text-lg font-medium mt-1" [innerHTML]="selectedStock.commentaire | nl2br"></div>
        }
    </ng-template>
</p-popover>
<p-confirmDialog />
@if (isLoadingData) {
    <div class="flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
    </div>
}
@else {
    <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 grid grid-cols-12 gap-4">
            <div class="col-span-8 flex relative justify-between border border-sky-500 dark:border-sky-400 px-4 py-2 mt-2 rounded-md">
                <span class="card  absolute top-0 -translate-y-1/2 border border-sky-500 dark:border-sky-400 text-sky-500 dark:text-sky-400 rounded-sm px-1.5! py-0.5!">Prix recommandé sur le marché</span>
                <div class="pt-2">
                    @if(isRecommendedPriceLoaded){
                        @if (recommendedPrice && recommendedPrice?.analyses) {
                            <div class="flex items-center py-1">
                                <p-tag [severity]="utilityService.getStateSeverity('NEUF')" [value]="utilityService.getStateLabel('NEUF')" />
                                @if (recommendedPrice.analyses.neuf && recommendedPrice.analyses.neuf.pv_conseille_min && recommendedPrice.analyses.neuf.pv_conseille_max) {
                                    <span class="ml-2">Entre</span>
                                    <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.neuf?.pv_conseille_min | currency: 'EUR' }}</code>
                                    <span>et</span>
                                    <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.neuf?.pv_conseille_max | currency: 'EUR' }}</code>
                                    <span> - Fiabilité :</span>
                                    @if (recommendedPrice.analyses.neuf.fiabilite) {
                                        <code class="mx-1" [class]="utilityService.getFiabilityClass(recommendedPrice.analyses.neuf.fiabilite)">{{ (recommendedPrice.analyses.neuf.fiabilite / 100) | percent:'1.0-2' }}</code>
                                    }
                                } @else {
                                    <span class="text-sky-500 dark:text-sky-400 ml-2">Aucun prix recommandé disponible</span>
                                }
                            </div>
                            <div class="flex items-center py-1">
                                <p-tag [severity]="utilityService.getStateSeverity('OCCASION')" [value]="utilityService.getStateLabel('OCCASION')" />
                                @if (recommendedPrice.analyses.occasion && recommendedPrice.analyses.occasion.pv_conseille_min && recommendedPrice.analyses.occasion.pv_conseille_max) {
                                    <span class="ml-2">Entre</span>
                                    <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.occasion?.pv_conseille_min | currency: 'EUR' }}</code>
                                    <span>et</span>
                                    <code class="text-sky-500 dark:text-sky-400 mx-1">{{ recommendedPrice.analyses.occasion?.pv_conseille_max | currency: 'EUR' }}</code>
                                    <span> - Fiabilité :</span>
                                    @if (recommendedPrice.analyses.occasion.fiabilite) {
                                        <code class="mx-1" [class]="utilityService.getFiabilityClass(recommendedPrice.analyses.occasion.fiabilite)">{{ (recommendedPrice.analyses.occasion.fiabilite / 100) | percent:'1.0-2' }}</code>
                                    }
                                }
                                @else {
                                    <span class="text-sky-500 dark:text-sky-400 ml-2">Aucun prix recommandé disponible</span>
                                }
                            </div>
                        }
                        @else {
                            <span class="text-sky-500 dark:text-sky-400">Aucun prix recommandé disponible</span>
                        }
                    }
                </div>
                @if(!isRecommendedPriceLoaded){
                    <i class="pi pi-spin pi-spinner text-sky-500 dark:text-sky-400"></i>
                }
                @else {
                    <p-button (click)="showChartModal()" icon="pi pi-chart-bar" size="small" severity="info" [outlined]="true"/>
                }
            </div>
            <div class="col-span-4 flex relative justify-between border border-purple-500 dark:border-purple-400 px-4 py-2 mt-2 rounded-md">
                <span class="card  absolute top-0 -translate-y-1/2 border border-purple-500 dark:border-purple-400 text-purple-500 dark:text-purple-400 rounded-sm px-1.5! py-0.5!">Prix Historique</span>
                <div class="pt-2">

                    @if(isHistoriquePricesLoaded){
                        @for (price of historyPrices; track price.id) {
                            <div class="flex items-center py-1">
                                <p-tag [severity]="utilityService.getStateSeverity(price.etat)" [value]="utilityService.getStateLabel(price.etat)" />
                                @if (price.prix) {
                                    <code class="text-purple-500 dark:text-purple-400 mx-1">{{ price.prix | currency: 'EUR' }}</code>
                                } @else {
                                    <span class="text-purple-500 dark:text-purple-400 ml-2">Aucun prix disponible</span>
                                }
                            </div>
                        }
                        @if (historyPrices.length === 0) {
                            <span class="text-purple-500 dark:text-purple-400">Aucun prix disponible</span>
                        }
                    }
                </div>
                @if(!isRecommendedPriceLoaded){
                    <i class="pi pi-spin pi-spinner text-purple-500 dark:text-purple-400"></i>
                }
            </div>
        </div>
        @for (stock of product.stocks; track $index) {
            <div class="col-span-12 lg:col-span-6 2xl:col-span-4">
                <p-card class="dark:border border-surface-600">
                    <ng-template #header>
                        <div class="grid grid-cols-2 gap-2 p-4 bg-surface-100 dark:bg-surface-800 rounded-md">
                            <div class="col-span-1 flex flex-col items-start gap-2">
                                <p-tag [severity]="utilityService.getStateSeverity(stock.etat)" [value]="utilityService.getStateLabel(stock.etat)" />
                                <p-rating [ngModel]="stock.note" [readonly]="true" class="mt-1" />
                            </div>
                            <div class="col-span-1 flex flex-col items-end gap-2 pt-0.5">
                                <span>{{ stock.prix | currency: 'EUR'}}</span>
                                <div class="flex flex-row gap-1">
                                    @if (stock.ebay) {
                                        @if (stock.url_ebay) {
                                            <a [href]="stock.url_ebay" target="_blank" pButton pTooltip="Lien Ebay" tooltipPosition="bottom" icon="pi pi-shopping-bag" size="small" [text]="true"></a>
                                        } @else {
                                            <span pTooltip="Ebay" tooltipPosition="bottom" class="pi pi-shopping-bag p-1.5 w-8 text-center !text-sm text-surface-500 dark:text-surface-400"></span>
                                        }
                                    }
                                    @if(stock.commentaire) {
                                        <p-button (click)="onStockPopOpen($event, stock)" pTooltip="Commentaire" tooltipPosition="bottom" icon="pi pi-info-circle" size="small" [text]="true" />
                                    }
                                    <p-button (click)="onStockMenuOpen($event, stock)" icon="pi pi-ellipsis-v" size="small" [outlined]="true"/>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                    <div class="flex items-center gap-2">
                        <div><span class="inline-block px-2 py-1 rounded-sm" [class]="utilityService.getSectorClassColor(stock.secteur?.nom)">{{ stock.secteur?.nom }}</span></div>
                        <div class="flex-1"><code>{{ `${stock.etagere} ${stock.rayon}` }}</code></div>
                        <div>
                            <!-- <p-chip [label]="`Quantité : ${stock.quantite}`" /> -->
                            <div class="flex flex-row bg-surface-100 dark:bg-surface-800 rounded-2xl">
                                <div class="flex justify-center items-center rounded-l-2xl border border-surface-200 dark:border-surface-700 pl-3 pr-2">Quantité : {{stock.quantite}}</div>
                                <div class="flex flex-col">
                                    @if (stock.quantite != null && stock.quantite > -1) {
                                        <p-button (click)="changeStockQuantity(stock, (stock.quantite + 1))" icon="pi pi-plus" size="small" severity="secondary" [outlined]="true" [loading]="isUpdatingStock" styleClass="rounded-b-none! rounded-l-none! rounded-tr-2xl! py-0.5! px-1.5!" class=""/>
                                        <p-button (click)="changeStockQuantity(stock, (stock.quantite - 1))" icon="pi pi-minus" size="small" severity="secondary" [outlined]="true" [loading]="isUpdatingStock" styleClass="rounded-t-none! rounded-l-none! rounded-br-2xl! py-0.5! px-1.5!"/>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        }
        <div class="col-span-12 lg:col-span-6 2xl:col-span-4">
            <button pButton [outlined]="true" class="w-full h-full" (click)="showStockModal(null)">
                <div class="flex flex-col items-center justify-center h-full py-2">
                    <span class="pi pi-plus text-primary-500 !text-2xl"></span>
                    <span class="text-xl">Ajouter un stock</span>
                </div>
            </button>
        </div>
    </div>
}
